import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../style/PushNotification.css';

const PushNotification = () => {
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [status, setStatus] = useState('');
    const [history, setHistory] = useState([]);
    const [showHistory, setShowHistory] = useState(false);
    const [image, setImage] = useState(null);

    useEffect(() => {
        fetchNotificationHistory();
    }, []);

    const fetchNotificationHistory = async () => {
        try {
            const response = await axios.get('https://api.alertapp.kz/api/v1/notifications/history');
            console.log("История уведомлений с сервера:", response.data); // Логируем данные, чтобы проверить

            setHistory(response.data);
        } catch (error) {
            console.error('Ошибка при получении истории уведомлений:', error);
        }
    };

    const handleSendNotification = async () => {
        if (!title || !body) {
            setStatus('Заполните все поля');
            return;
        }

        const formData = new FormData();
        formData.append('title', title);
        formData.append('body', body);
        if (image) {
            formData.append('image', image);
        }

        try {
            await axios.post(
                'https://api.alertapp.kz/api/v1/notifications/send-notifications',
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                }
            );
            setStatus('Уведомление отправлено');
            setTitle('');
            setBody('');
            setImage(null);
            await fetchNotificationHistory();
        } catch (error) {
            setStatus('Ошибка при отправке уведомления');
            console.error(error);
        }
    };

    const handleImageChange = (event) => {
        setImage(event.target.files[0]);
    };

    return (
        <div className="push-notification-container">
            <h2>Отправка Push-уведомления</h2>
            <input
                type="text"
                placeholder="Название"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="input-field"
            />
            <textarea
                placeholder="Сообщение"
                value={body}
                onChange={(e) => setBody(e.target.value)}
                className="textarea-field"
            />
            <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="input-file"
            />
            <button onClick={handleSendNotification} className="submit-btn">
                Отправить
            </button>
            {status && <p className="status-text">{status}</p>}

            <button onClick={() => setShowHistory(!showHistory)} className="history-btn">
                {showHistory ? 'Скрыть историю' : 'Показать историю'}
            </button>

            {showHistory && (
                <div className="notification-history">
                    <h3>История отправленных уведомлений</h3>
                    <ul>
                        {history.length === 0 ? (
                            <li>Нет отправленных уведомлений</li>
                        ) : (
                            history.map((item, index) => (
                                <li key={index} className="history-item">
                                    <strong>Название:</strong> {item.title} <br />
                                    <strong>Сообщение:</strong> {item.body} <br />
                                    <strong>Изображение:</strong> {item.imageUrl} <br />
                                    <strong>Дата отправки:</strong> {new Date(item.dateSent || item.createdAt).toLocaleString()} <br />
                                </li>
                            ))
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default PushNotification;
